import type { FC } from "react";

import { Text } from "@hightouch/htui";

import { AuthLayout } from "src/components/auth/auth-layout";
import { AuthCard } from "src/components/auth/auth-card";

export const Expired: FC = () => {
  return (
    <AuthLayout metaTitle="Expired invitation">
      <AuthCard heading="Expired invitation" gap={4}>
        <Text>
          Check that your account email is the same as the invite recipient or
          contact your workspace administrator.
        </Text>
      </AuthCard>
    </AuthLayout>
  );
};
